import React from "react";

import VideoContentSection from "./VideoContentSection";
import FranchiseOwnerSummarySection from "./FranchiseOwnerSummarySection";
import { Container } from "./styled";

const FranchiseInfo = () => {
  return (
    <Container>
      <VideoContentSection />
      <FranchiseOwnerSummarySection />
    </Container>
  );
};

export default FranchiseInfo;
